import { createFileRoute } from "@tanstack/react-router";
import Pending from "../components/Pending";

export const Route = createFileRoute("/pending")({
  component: Pending,
});
